"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createRoutesFromChildren;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _excluded = ["caseSensitive", "element", "index", "path", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*
 * This function is taken from React Router V6, but with some added functionality.
 * React Router's version does not spread the rest of the props.
 * We added this functionality so we can get our special added props ex: isAnonymous, forceSignOut etc.
 * https://github.com/remix-run/react-router/blob/7668662895337af01f0a8eb22788e0e6b2f5e344/packages/react-router/index.tsx#L755
 */
function createRoutesFromChildren(children) {
  var routes = [];
  _react.default.Children.forEach(children, function (element) {
    if (! /*#__PURE__*/_react.default.isValidElement(element)) {
      // Ignore non-elements. This allows people to more easily inline
      // conditionals in their route config.
      return;
    }
    if (element.type === _react.default.Fragment) {
      // Transparently support React.Fragment and its children.
      routes.push.apply(routes, routes.concat(_toConsumableArray(createRoutesFromChildren(element.props.children))));
      return;
    }

    // Warn if it is not a Route component
    if (element instanceof _reactRouterDom.Route) {
      console.warn("[".concat(typeof element.type === 'string' ? element.type : element.type.name, "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>"));
    }
    var _element$props = element.props,
      caseSensitive = _element$props.caseSensitive,
      routeElement = _element$props.element,
      index = _element$props.index,
      path = _element$props.path,
      excludeChildren = _element$props.children,
      restProps = _objectWithoutProperties(_element$props, _excluded);
    var route = {
      caseSensitive: caseSensitive,
      index: index,
      path: path,
      element: routeElement,
      // This is the added functionality, spread the rest of the props into the route object
      props: restProps
    };
    if (element.props.children) {
      route.children = createRoutesFromChildren(element.props.children);
    }
    routes.push(route);
  });
  return routes;
}